//
// Copyright (c) 2011-2017 by Curalate, Inc.
//

export const PROMOTED_POSTS_TREND_VALUES = {
  TOTAL_CLICKS: 'clicks',
  TOTAL_REVENUE: 'revenue',
  AMOUNT_SPENT: 'spend',
} as const;

export const PROMOTED_POSTS_TREND_VALUE_LABELS = {
  [PROMOTED_POSTS_TREND_VALUES.TOTAL_CLICKS]: 'Total Clicks',
  [PROMOTED_POSTS_TREND_VALUES.TOTAL_REVENUE]: 'Total Revenue',
  [PROMOTED_POSTS_TREND_VALUES.AMOUNT_SPENT]: 'Amount Spent',
};
